import React from "react";
import PropTypes from "prop-types";
import Grid from "@material-ui/core/Grid";
import { compose } from "recompose";
import { withRouter } from "react-router-dom";
import { withStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import BaseButton from "components/UI/Buttons/BaseButton";
import Button from "@material-ui/core/Button";
import RefreshIcon from "@material-ui/icons/Refresh";
import titleCase from "title-case";

const styles = theme => ({
  root: {
    flexGrow: 1,
  },
  button: {
    margin: theme.spacing.unit,
    height: 32,
  },
  alignRight: {
    display: "flex",
    justifyContent: "flex-end",
  },
});

class IndexToolBar extends React.Component {
  handleCreate = e => {
    e.preventDefault();
    const { history, match } = this.props;
    history.push(`${match.url}/create`);
  };

  handleReload = e => {
    e.preventDefault();
    console.warn("Reload Data: ", this.props.moduleName);
  };

  render() {
    const { classes, moduleName } = this.props;

    return (
      <div className={classes.root}>
        <Grid container spacing={16} alignItems="center">
          <Grid item xs={12} sm={6}>
            <Typography component="h2" variant="h5">
              {titleCase(moduleName)}
            </Typography>
          </Grid>
          <Grid item xs={12} sm={6} className={classes.alignRight}>
            <BaseButton
              variant="contained"
              color="primary"
              className={classes.button}
              onClick={this.handleCreate}
            >
              Create
            </BaseButton>
            <Button
              variant="outlined"
              color="default"
              disabled
              className={classes.button}
              onClick={this.handleReload}
            >
              <RefreshIcon />
            </Button>
          </Grid>
        </Grid>
      </div>
    );
  }
}

IndexToolBar.propTypes = {
  moduleName: PropTypes.string.isRequired,
};

export default compose(
  withRouter,
  withStyles(styles)
)(IndexToolBar);
